export class ControlDocumentCarrier {
  constructor(
      public defaultControlDocumentCarrier?: string,
  ) { }

  clone() {
    return new ControlDocumentCarrier(
        this.defaultControlDocumentCarrier
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/control-document-carrier.ts